<template>
    <div class="bestellFiles">
        <router-view></router-view>
        <div class="bestellFilestop"></div>
        <div class="bestellFilesHolder">
            <div class="bestellFilesNoDoc" v-if="bestellFiles.length < 1">
                Keine Dokumente Vorhanden
            </div>
            <div class="bestellFilesButton"
                 v-for="item in bestellFiles"
                 :key="item.id"
                 @click="downloadFile(item)"
            >
                {{item}}
            </div>

        </div>
    </div>
</template>

<script>
import http from '../../http/http';

export default {
    components: {},
    data() {
        return {
            // bestellFiles: []

        }
    },
    props: {
        stao: {
            type: String,
            default: '1'
        }
    },
    computed: {
        userLev() {
            return this.$store.getters['user/autLev'];
        },
        bestellFiles() {
            return this.$store.getters['lager/bestellFiles'];
        },
        apiurl() {
            return http.defaults.baseURL;
        }

    },
    watch: {},
    methods: {
        downloadFile(file) {
            let data = {
                url: this.apiurl,
                fileName: file
            }

            this.$store.dispatch('lager/bestellFilesDownload', data);
        }

    },
    beforeDestroy() {
    },
    created() {
    },
    mounted() {
        this.$store.dispatch('lager/bestellFiles', { stao: this.stao });
    }
}
</script>

<style scoped lang="scss">

    .bestellFiles {
        position: absolute;
        width: 100%;
        height: 100vh;
        /*overflow-y: scroll;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: $color-white;
    }

    .bestellFilesNoDoc {
        font-size: 2rem;
        color: $color-red;
        text-align: center;
    }

    .bestellFilesHolder {
        display: flex;
        flex-direction: column;
        width: 100%;
        /*height: 100vh;*/
        /* overflow-y: scroll; */
    }

    .bestellFilesButton {
        width: 100%;
        font-size: 2rem;
        text-align: center;
        /*height: 3rem;*/
        cursor: pointer;
        padding: 0.625rem;
    }

    .bestellFilesButton:hover {
        background-color: $color-gray;
    }

    .bestellFilesButton:active {
        background-color: $color-green;
    }

    .bestellFilestop {
        height: 70px;
    }

    @include medium {

        .bestellFilestop {
            display: none;
        }

        .bestellFilesHolder {
            /*width: 31rem;*/
            @include default-shadow;
        }
    }

    @include extra-large {

        .bestellFilesHolder {
            /*width: 1000px;*/
            @include default-shadow;
            /*height: 80vh;*/
        }
    }

</style>
